import { ref } from 'vue';

function getInitialExpanded(): boolean {
  if (typeof window === 'undefined') return true;
  return !window.matchMedia('(max-width: 767px)').matches; // collapsed on mobile (md breakpoint)
}

const menuExpanded = ref(getInitialExpanded());

export function useMenuExpanded() {
  return menuExpanded;
}
